const Localization = require("../models/Localization.js");
const PowerButton = require("../models/atouchaway/PowerButton.js");
const MachineTracker = require("../models/atouchaway/MachineTracker.js");
const OrientationLocker = require("../models/orientation/OrientationLocker.js");
const DeviceButtons = require("../models/atouchaway/DeviceButtons.js");
const ScreenSaver = require("../models/atouchaway/ScreenSaver.js");
const UserMetrics = require("../models/usermetrics/UserMetrics.js");

const create = require("./create");

const models = [
	MachineTracker,
	Localization,
	PowerButton,
	OrientationLocker,
	DeviceButtons,
	ScreenSaver,
	UserMetrics,
];

module.exports = create(models, "power");
